export default __webpack_public_path__ + "static/media/hoserhockey.89c5f9f0.png";